module.exports = __webpack_public_path__ + "static/media/economics_explain.f88c9163.jpg";